import React, { useState } from 'react'

import { t } from 'i18next'

import { VerticalChevron } from '@/shared/icons/VerticalChevron'

import { TAccordionDogoProps, TAccordionProps, TPaymentAccordionProps } from './types'

export const Accordion = ({ title, body }: TAccordionProps) => {
  const [isOpened, setIsOpened] = useState<boolean>(false)

  const onClick = () => {
    setIsOpened(!isOpened)
  }

  let className = 'accordion'
  if (!isOpened) {
    className += ' hidden'
  }

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    <div className={className} onClick={onClick}>
      <div className="title">
        <span>{title}</span>
        <VerticalChevron />
      </div>
      <div className="body" dangerouslySetInnerHTML={{ __html: body }}></div>
    </div>
  )
}

export const PaymentAccordion = ({
  title,
  icon,
  body,
  id,
  isOpen,
  onToggle,
  receiptData,
}: TPaymentAccordionProps) => {
  const className = `accordion ${id} ${isOpen ? '' : 'hidden'}`
  const secureText =
    t('paymentScreenPage.receiptData.secureInfo') ||
    'Your payment information is secure with SSL/TLS encryption'

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    <div className={className} onClick={() => onToggle(id)}>
      <div className="header">
        <div className="wrapper">
          <input type="radio" checked={isOpen} readOnly className="radio-button" />
          <span>{title}</span>
        </div>
        <div className="brand-container">{icon}</div>
      </div>
      <div className="body">
        <div className="total-container">
          <div className="description">{receiptData.totalPrice.textPlan}</div>
          <div className="price-container">
            <div className="crossed-price">{receiptData.priceInfo[0].textPrice}</div>
            <div className="price">{receiptData.totalPrice.textPrice}</div>
          </div>
        </div>
        <div className="payment-method">{body}</div>
        <div className="secure">{secureText}</div>
      </div>
    </div>
  )
}

export const AccordionDogo = ({
  title,
  text,
  caption,
  list,
  description,
  image,
  stages,
}: TAccordionDogoProps) => {
  const [isOpened, setIsOpened] = useState<boolean>(false)

  const onClick = () => {
    setIsOpened(!isOpened)
  }

  let className = 'accordion'
  if (!isOpened) {
    className += ' hidden'
  }

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    <div className={className} onClick={onClick}>
      <div className="title">
        <span>{title}</span>
        <VerticalChevron strokeColor="#2F5C3D" />
      </div>
      <div className="header">
        <div className="text-container">
          <div className="text">{text}</div>
          <span className="label"></span>{' '}
        </div>
        <div className="caption">{caption}</div>
        <div className="list">{list}</div>
        <div className="description" dangerouslySetInnerHTML={{ __html: description }}></div>
      </div>
      <div className="image">
        <img src={image.src} alt="dog" />
      </div>
      {stages && (
        <div className="stages">
          <div className="stages-title">
            <span className="highlight">Your Dog</span> journey
          </div>
          {stages.map((stage, index) => (
            <div key={index} className="stage-item">
              <div className="stage-time" dangerouslySetInnerHTML={{ __html: stage.time }}></div>
              <div className="stage-description">{stage.description}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export type { TAccordionProps }
